import { render, staticRenderFns } from "./ItemModelBaseData.vue?vue&type=template&id=7d971e66&scoped=true"
import script from "./ItemModelBaseData.vue?vue&type=script&lang=js"
export * from "./ItemModelBaseData.vue?vue&type=script&lang=js"
import style0 from "./ItemModelBaseData.vue?vue&type=style&index=0&id=7d971e66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d971e66",
  null
  
)

export default component.exports